<template>
  <el-drawer
    :title="title"
    :visible.sync="showDrawer"
    :with-header="true"
    :before-close="handleClose"
    :size="drawerWidth"
    :withHeader="withHeader"
  >
    <div v-if="isLoading" class="min-h-screen flex items-center justify-center">
      <spinner />
    </div>
    <section v-else class="py-4 -mt-5 overflow-scroll">
      <!-- header -->
      <div
        class="h-28 w-full sticky top-1 z-10 text-default pt-5 pb-16 bg-muted py-8 px-8 flex items-center justify-between transition-all duration-300 ease-linear"
      >
        <h3 class="font-semibold test-sm">
          {{ title }}
        </h3>
        <close-icon @click.native="handleClose" size="h-5 w-5 cursor-pointer" />
      </div>
      <div class="flex justify-center sticky left-0 right-0 z-30 -mt-3">
        <payment-fund-icon v-if="isTransactionPayLink" />
        <transaction-arrow v-else :transactionType="transactionType" />
      </div>
      <div class="">
        <transition name="fade-in">
          <component
            :is="computeComponentType"
            :transactionDetails="transactionDetails"
            :rateIncreased="rateIncreased"
            @handleApproveWithdrawal="handleApproveWithdrawal"
            @handleCancelWithdrawal="handleCancelWithdrawal"
            class="px-4"
          />
        </transition>
      </div>
    </section>
  </el-drawer>
</template>
<script>
import breakpoints from '@/utils/breakpoints.js'
import notification from '@/mixins/notification.js'
import app from '@/mixins/app.js'

export default {
  mixins: [notification, app],
  name: 'Drawer',
  data () {
    return {
      breakpoints,
      isLoading: false,
      showDepositDetails: false,
      activeComponent: 'deposit-details',
      withHeader: false
    }
  },
  props: {
    showDrawer: {
      type: Boolean,
      required: true
    },
    transactionDetails: {
      type: Object,
      default: () => {},
      required: true
    },
    rateIncreased: {
      type: Boolean,
      default: () => false
    },
    transactionType: {
      type: String,
      default: () => '',
      required: true
    }
  },
  components: {
    Spinner: () => import('@/components/v2/app/Spinner.vue'),
    TransactionArrow: () => import('@/assets/v2/icons/TransactionArrow.vue'),
    Deposit: () =>
      import(
        '@/components/v2/transactions/drawers/transactionDrawer/Deposit.vue'
      ),
    Withdrawal: () =>
      import(
        '@/components/v2/transactions/drawers/transactionDrawer/Withdrawal.vue'
      ),
    payLink: () =>
      import(
        '@/components/v2/transactions/drawers/transactionDrawer/PaymentLinkTransactionDetails.vue'
      ),
    CloseIcon: () => import('@/assets/v2/icons/CloseIcon.vue'),
    Transition: () =>
      import('@/components/v2/animation/transition/Transition.vue'),
    PaymentFundIcon: () => import('@/assets/v2/icons/PaymentFundIcon.vue')
  },
  computed: {
    transactionInfo () {
      return this.$store?.state?.transactions?.transactionDetails
    },
    computeComponentType () {
      return this.transactionType
    },
    transferId () {
      return this.$route.params.id
    },
    drawerWidth () {
      return breakpoints.lgAndUp ? '30%' : breakpoints.mdAndUp ? '50%' : '90%'
    },
    isSecondPage () {
      return this.activeComponent === 'second-page'
    },
    isTransactionDeposit () {
      return this.transactionType === this.$transactionType.DEPOSIT
    },
    isTransactionWithdrawal () {
      return this.transactionType === this.$transactionType.WITHDRAWAL
    },
    isTransactionPayLink () {
      return this.transactionType === 'payLink'
    },
    title () {
      let title = ''
      switch (this.transactionType) {
        case 'deposit':
          title = 'Deposit Details'
          break
        case 'withdrawal':
          title = 'Withdrawal Details'
          break
        case 'payLink':
          title = 'Customer Details'
          break
      }
      return title
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDrawer')
    },
    handleApproveWithdrawal (actionType) {
      this.$emit('handleApproveWithdrawal', actionType)
    },
    handleCancelWithdrawal (actionType) {
      this.$emit('handleCancelWithdrawal', actionType)
    },
    async getTransactionDetails () {
      this.isLoading = true
      const payload = {
        transactionType: this.transactionDetails.type
          ? this.transactionDetails.type
          : this.updatedNotificationType,
        transactionId: this.transactionDetails.id
          ? this.transactionDetails.id
          : this.notificationID
      }
      await this.$store
        .dispatch('transactions/getTransactionById', payload)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.handleErrorResponseNotification(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  mounted () {
    this.getTransactionDetails()
    if (
      this.transactionDetails.status === this.$STATUS.AWAITING_BUSINESS_APPROVAL
    ) {
      this.getInitiatorDetails()
    }
  }
}
</script>
<style scoped>
>>> .el-drawer__header > :first-child {
  font-size: 0.9rem;
  color: var(--text-2);
  font-weight: 600;
}
>>> .el-drawer__header {
  color: var(--text-4);
  font-size: 1.2rem;
  padding-bottom: 1rem;
  padding-top: 2rem;
  padding-left: 1.4rem;
  font-weight: 700;
  border-bottom: 1px solid var(--border-2);
}
>>> .el-drawer {
  background: var(--background-9) !important;
}
>>> .el-input--prefix .el-input__inner {
  border: 1px solid var(--border-1);
  border-radius: 8px;
  margin: 0, 6px;
  font-size: 0.9rem;
  color: var(--text-2);
  font-weight: 400;
  padding-left: 40px;
  background: var(--background-10);
}
.small-text {
  font-size: 0.6rem;
}
>>> li.number.active {
  background-color: var(--background) !important;
  border: 0.5px solid var(--color-primary) !important;
  box-sizing: border-box;
  border-radius: 100px;
  font-weight: 400;
  color: var(--color-primary) !important ;
}
>>> li.number {
  background-color: var(--background) !important;
  border: 0.5px solid var(--text-1) !important;
  box-sizing: border-box;
  border-radius: 100px !important;
  font-weight: 400;
}
</style>
